import { SectionHeader } from "@sprout/typography.tsx";
import Preferences from "@components/preferences.tsx";
import { useTranslation } from "react-i18next";
import "@components/job_alerts/header.scss";

type JobAlertsHeaderProps = {
  jobAlertsPaused?: boolean;
};

export const JobAlertsHeader = ({ jobAlertsPaused }: JobAlertsHeaderProps) => {
  const { t } = useTranslation("jobAlerts");

  return (
    <div className="job-alerts-page__header">
      <SectionHeader as="h2">{t("title")}</SectionHeader>
      {jobAlertsPaused === false && (
        <div className="job-alerts-page__header__preferences">
          <Preferences />
        </div>
      )}
    </div>
  );
};
